if (!customElements.get('sticky-add-to-cart-button')) {
    customElements.define(
      'sticky-add-to-cart-button',
      class StickyAddToCartButton extends HTMLElement {
        constructor() {
          super();
          this.onScrollHandler = this.onScrollHandler.bind(this);
          this.onButtonClick = this.onButtonClick.bind(this);
          this.onCartButtonWrapperChange = this.onCartButtonWrapperChange.bind(this);
        
          this.cartButton = document.querySelector('form.form[action="/cart/add"] button[type="submit"][name="add"]');
          this.button = this.querySelector('#sticky-mobile-add-to-cart');
          
          
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.button.addEventListener('click', this.onButtonClick);
          
          const observer = new MutationObserver(() => this.onCartButtonWrapperChange());
          observer.observe(document.querySelector('.product-form__buttons'),{childList: true, subtree: true});

          this.button.innerHTML = this.cartButton.innerHTML;
          this.cartButtonSpan = document.querySelector('form.form[action="/cart/add"] button[type="submit"][name="add"] span');
          this.buttonSpan = this.querySelector('#sticky-mobile-add-to-cart span');
          this.buttonSpinner = this.button.querySelector('.loading__spinner');
        }

        onScrollHandler(ev) {
          const { top, left, bottom, right } = this.cartButton.getBoundingClientRect();
          const { innerHeight, innerWidth } = window;
          const visible = top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
          this.button.style.display = this.cartButton && innerWidth < 750 && !visible && top <= 9 ? 'flex' : 'none';
        }

        onButtonClick() {
          this.cartButton.click();
        }

        onCartButtonWrapperChange(ev) {
          this.buttonSpan.innerHTML = this.cartButtonSpan.innerHTML;
          var disabled = this.cartButton.getAttribute('aria-disabled');
          if (disabled) {
            this.button.classList.add('loading');
            this.buttonSpinner.classList.remove('hidden');
          } else {
            this.button.classList.remove('loading');
            this.buttonSpinner.classList.add('hidden');
          }
        }
      }
    );
  }
  